import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-20 text-center">
      <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-5">
        <i className="ri-error-warning-line text-3xl text-foreground-400" />
      </div>
      <h1 className="text-xl font-semibold text-foreground-900">页面不存在</h1>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">
        未找到页面
        <span className="font-mono text-foreground-600"> {location.pathname}</span>
        ，请检查地址是否正确。
      </p>
      <Link
        to="/goods"
        className="mt-6 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-white text-sm hover:bg-primary-600 transition-colors"
      >
        <i className="ri-home-4-line" />
        返回物资首页
      </Link>
    </div>
  );
}
